import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../hooks/use-services.hook";
import {FlightsDatesSelector} from "../../../../services/flight-search/dates-selection/flights-dates-selector";
import {composeFlightDatesDropDownHeaderTitle} from "../compose-flight-dates-drop-down-header-title";

interface FlightDatesDropdownHeaderInClosedStateComponentProps {
    datesSelector: FlightsDatesSelector;
}

export const FlightDatesDropdownHeaderInClosedStateComponent: React.FC<FlightDatesDropdownHeaderInClosedStateComponentProps> = observer(props => {
    const services = useServices();
    return (
        <>
            {composeFlightDatesDropDownHeaderTitle(props.datesSelector.searchController, services)}
        </>
    )

});
